import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Flex, Icon, Box, Dropdown } from '@cowsquare/design';
import posed, { PoseGroup } from 'react-pose';

const ArrowIcon = styled(Icon).attrs({
  name: 'ARROW_DOWN',
})`
  transition: transform 300ms;
  transform: ${props => (props.isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const RoleBlock = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'space-between',
})`
  width: 160px;
  height: 60px;
  padding: 0 10px;
  border-left: 1px solid rgba(0, 0, 0, 0.05);
  border-right: 1px solid rgba(0, 0, 0, 0.05);
  cursor: pointer;
`;

const Label = styled.h3`
  color: rgba(0, 0, 0, 0.7);
  font-size: 14px;
  font-weight: normal;
  margin: 0;
  user-select: none;
`;

export const RoleDropdown = ({ selectedItem, onChange, options }) => {
  return (
    <Dropdown
      itemToString={item => item.name}
      selectedItem={selectedItem}
      onChange={onChange}
      options={options}
      render={({ toggleMenu, getInputProps, isOpen }) => (
        <RoleBlock onClick={toggleMenu} {...getInputProps()}>
          <Flex flexDirection="row" alignItems="center">
            <Box mr="5px">{selectedItem.icon}</Box>
            <Label>{selectedItem.name}</Label>
          </Flex>
          <ArrowIcon isOpen={isOpen} />
        </RoleBlock>
      )}
    />
  );
};

const MobileRoleBlock = styled(RoleBlock)`
  width: 100%;
  border: none;
  padding: 0 16px;
`;

const MobileAnimation = posed.div({
  enter: {
    opacity: 1,
    transition: { duration: 300, ease: 'circOut' },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0, ease: 'backOut' },
    delay: 0,
  },
});

const MobileMenuWrapper = styled(MobileAnimation)`
  display: flex;
  flex-flow: column;
  outline: 0;
  transform-origin: top;
`;

const MobileMenu = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

const MobileItem = styled.li`
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
  color: #62646a;
  font-size: ${themeGet('dropdown.option.fontSize')};
  cursor: pointer;
`;

const OptionBlock = styled(Flex).attrs({
  alignItems: 'center',
})`
  height: 50px;
`;

export const MobileRoleDropdown = ({ selectedItem, onChange, options }) => {
  return (
    <Dropdown
      itemToString={item => item.name}
      selectedItem={selectedItem}
      onChange={onChange}
      onOuterClick={event => event.openMenu()}
      render={({ toggleMenu, getMenuProps, getItemProps, getInputProps, isOpen, highlightedIndex }) => {
        return (
          <>
            <MobileRoleBlock onClick={toggleMenu} {...getInputProps()}>
              <Flex flexDirection="row" alignItems="center">
                <Box mr="16px">{selectedItem.icon}</Box>
                <Label>{selectedItem.name}</Label>
              </Flex>
              <ArrowIcon isOpen={isOpen} />
            </MobileRoleBlock>
            <PoseGroup>
              {isOpen && (
                <MobileMenuWrapper key="mobile-menu">
                  <MobileMenu {...getMenuProps()}>
                    {options
                      .filter(item => item !== selectedItem)
                      .map((item, index) => (
                        <MobileItem
                          key={item.name}
                          {...getItemProps({
                            item,
                            index,
                            hovered: highlightedIndex === index,
                            selected: selectedItem === item,
                            disabled: item.disabled,
                          })}
                        >
                          <OptionBlock>
                            <Box mr="16px">{item.icon}</Box>
                            <Label>{item.name}</Label>
                          </OptionBlock>
                        </MobileItem>
                      ))}
                  </MobileMenu>
                </MobileMenuWrapper>
              )}
            </PoseGroup>
          </>
        );
      }}
    />
  );
};
